import { connect } from 'react-redux';
import React, { useState, useEffect } from 'react';
import ReactEcharts from '../Echarts/Echarts';
import { UploadOutlined } from '@ant-design/icons';
import StyledTable from '../../../../../commons/styles/table';
import { Form, Button, Select, Input, Upload, message, Tabs } from 'antd';

const { TabPane } = Tabs;

const Measurement = (props) => {
  const option ={
    xAxis: {
      type: 'category',
      data: [0.0, 0.15, 0.3, 0.45, 0.6, 0.75, 1.0]
    },
    yAxis: {
      type: 'value'
    },
    series: [
      {
        data: [2000, 3000, 4000, 5000, 6000, 7000],
        type: 'line'
      }
    ]
  };
  const [selectedTab, setSelectedTab] = useState('CM');
  const [translationCache, setTranslationCache] = useState(props.translationCache || []);

  useEffect(() => {
    if (props.translationCache !== translationCache) {
      setTranslationCache(props.translationCache);
    }
  }, [props.translationCache]);

  const translation = (keyword) => {
    return translationCache && translationCache[keyword] ? translationCache[keyword] : keyword;
  };

  const formItemLayout = {
    labelCol: {
      span: 4
    },
    wrapperCol: {
      span: 14
    }
  };
  const buttonItemLayout = {
    wrapperCol: {
      span: 14,
      offset: 4
    }
  };
  const columns = [
    {
      title: translation('No'),
      dataIndex: 'No',
      key: 'No'
    },
    {
      title: translation('Sample Name'),
      dataIndex: 'SampleName',
      key: 'SampleName'
    },
    {
      title: translation('Date'),
      dataIndex: 'Date',
      key: 'Date'
    },
    {
      title: translation('CH'),
      dataIndex: 'ch',
      key: 'ch'
    },
    {
      title: translation('Channel Name'),
      dataIndex: 'Channel Name',
      key: 'Channel Name'
    },
    {
      title: translation('Measured Value'),
      dataIndex: 'DV',
      key: 'DV'
    }
  ];
  const dataSource = [
    {
      key: '1',
      name: translation('Mike'),
      age: 32,
      address: translation('10 Downing Street')
    },
    {
      key: '2',
      name: translation('John'),
      age: 42,
      address: translation('10 Downing Street')
    }
  ];
  let UploadProps = {
    name: 'file',
    action: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',
    headers: {
      authorization: 'authorization-text'
    },
    onChange(info) {
      if (info.file.status === 'done') {
        message.success(`${info.file.name} file uploaded successfully`);
      } else if (info.file.status === 'error') {
        message.error(`${info.file.name} file upload failed.`);
      }
    }
  };

  return (
    <div >
      <Tabs
        defaultActiveKey={selectedTab}
        onChange={(value) => setSelectedTab(value)}
        type="card"
      >
        <TabPane tab={translation('Continuous Measurement')} key={'CM'}>
          <Form
            {...formItemLayout}
            layout="horizontal"
            name={translation('CM')}
            style={{ margin: '19px', padding: '30px' }}
          >
            <Form.Item label={translation('HD')}>
              <Select style={{ width: 220 }}>
                <Select.Option value="01">01</Select.Option>
              </Select>
            </Form.Item>
            <Form.Item label={translation('CH')}>
              <Select style={{ width: 220 }}>
                <Select.Option value="01">01</Select.Option>
              </Select>
            </Form.Item>
            <Form.Item {...buttonItemLayout}>
              <Button type="primary" style={{ margin: '10px' }}>
                {translation('Cut Off')}
              </Button>
            </Form.Item>

            <Form.Item label={translation('Recording Cycle')}>
              <Select style={{ width: 220 }}>
                <Select.Option value="10">10</Select.Option>
              </Select>
            </Form.Item>
            <Form.Item label={translation('Automatic file')}>
              <Select style={{ width: 220 }}>
                <Select.Option value="1">1</Select.Option>
              </Select>
            </Form.Item>
            <Form.Item label={translation('Interval statistics')}>
              <Select style={{ width: 220 }}>
                <Select.Option value="1">1</Select.Option>
              </Select>
            </Form.Item>
          </Form>
          <div>
            <Button style={{ margin: '19px' }} type="primary">
              {translation('Indication of the result of measurement file')}
            </Button>
            <Button style={{ margin: '19px' }} type="primary">
              {translation('Setting of the result of measurement file')}
            </Button>
          </div>

          <ReactEcharts
            option={option}
            notMerge={true}
            lazyUpdate={true}
            style={{ margin: '19px', padding: '30px' }}
            className="react_for_echarts"
          />
        </TabPane>
        <TabPane tab={translation('Single Measurement')} key={'SM'}>
          <div style={{}}>
            <Form
              {...formItemLayout}
              layout="horizontal"
              name={translation('SM')}
              style={{ margin: '19px', padding: '30px' }}
            >
              <Form.Item label={translation('HD')}>
                <Select style={{ width: 220 }}>
                  <Select.Option value="01">01</Select.Option>
                </Select>
              </Form.Item>
              <Form.Item label={translation('CH')}>
                <Select style={{ width: 220 }}>
                  <Select.Option value="01">01</Select.Option>
                </Select>
              </Form.Item>
              <Form.Item label={translation('CutChip')}>
                <div>24.1</div>
              </Form.Item>
              <Form.Item {...buttonItemLayout}>
                <Button type="primary">{translation('Measurement')}</Button>
              </Form.Item>
            </Form>
            <div
              style={{ margin: '19px', padding: '30px' }}
            >
              <label style={{  fontWeight: 'bold' }}>
                {translation('Measurement Log')}
              </label>
              <StyledTable size="small"
                dataSource={dataSource}
                columns={columns}
                pagination={false}
                bordered
              />
            </div>
          </div>
        </TabPane>
        <TabPane tab={translation('Batch Measurement')} key={'BM'}>
          <div style={{}}>
            <Form
              {...formItemLayout}
              layout="horizontal"
              name="BM"
              style={{ margin: '19px', padding: '30px' }}
            >
              <Form.Item label={translation('HD')}>
                <Select style={{ width: 220 }}>
                  <Select.Option value="01">01</Select.Option>
                </Select>
              </Form.Item>
              <Form.Item label={translation('CH')}>
                <Select style={{ width: 220 }}>
                  <Select.Option value="01">01</Select.Option>
                </Select>
              </Form.Item>

              <Form.Item label={translation('Recording')}>
                <Select style={{ width: 220 }}>
                  <Select.Option value="1">1</Select.Option>
                </Select>
                {translation('Sec')}
              </Form.Item>
              <Form.Item label={translation('Recording Time')}>
                <Input style={{ width: 220 }} />
                {translation('Minute')}
              </Form.Item>
              <Form.Item label={translation('Folder Settings')}>
                <Upload {...UploadProps}>
                  <Button type='primary' icon={<UploadOutlined />}>{translation('Click to Upload')}</Button>
                </Upload>
              </Form.Item>
              <Form.Item label={translation('Recording file')}>
                <Button type="dashed">{translation('Click to record')}</Button>
              </Form.Item>
            </Form>

            <div
              style={{ margin: '19px', padding: '30px' }}
            >
              <StyledTable size="small"
                dataSource={dataSource}
                columns={columns}
                pagination={false}
                bordered
              />
              <ReactEcharts
                option={option}
                notMerge={true}
                lazyUpdate={true}
                className="react_for_echarts"
              />
              <ReactEcharts
                option={option}
                notMerge={true}
                lazyUpdate={true}
                className="react_for_echarts"
              />
            </div>
          </div>
        </TabPane>
        <TabPane tab={translation('Channel Select')} key={'CS'}>
          <Form
            {...formItemLayout}
            layout="horizontal"
            name={translation('HeaderNumber_current')}
            style={{ margin: '19px', padding: '30px' }}
          >
            <Form.Item label="HD">
              <Select style={{ width: 220 }}>
                <Select.Option value="01">01</Select.Option>
              </Select>
            </Form.Item>
          </Form>
          <Form
            {...formItemLayout}
            layout="horizontal"
            name={translation('HeaderNumber_change')}
            style={{ margin: '19px', padding: '30px' }}
          >
            <label style={{  fontWeight: 'bolder' }}>
              {translation('Current Measurement Channel')}
            </label>
            <Form.Item label="CH">
              <Select style={{ width: 220 }}>
                <Select.Option value="01">01</Select.Option>
              </Select>
            </Form.Item>
            <Form.Item label={translation('Channel Name')}>
              <div>{translation('CutChip')}</div>
            </Form.Item>
          </Form>
        </TabPane>
      </Tabs>
    </div>
  );
};

const mapStateToProps = (state) => ({
  translationCache: state.TranslationReducer.translationCache
});

export default connect(mapStateToProps)(Measurement);
